<template>
  <div class="protocol-page">
    <div class="protocol-container">
      <div class="protocol-content markdown-body" v-html="htmlContent" />
    </div>
  </div>
</template>

<script>
import { marked } from 'marked'
import { loadProtocolDoc, getPageTitle } from './utils'

marked.setOptions({
  breaks: true,
  gfm: true
})

export default {
  name: 'ProtocolPage',
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['user', 'privacy'].includes(value)
    }
  },
  data() {
    return {
      htmlContent: ''
    }
  },
  computed: {
    langParam() {
      return this.$route.query.la || ''
    }
  },
  watch: {
    langParam: {
      immediate: true,
      handler() {
        this.renderDoc()
      }
    }
  },
  methods: {
    renderDoc() {
      const markdown = loadProtocolDoc(this.type, this.langParam)
      if (!markdown) return
      this.htmlContent = marked.parse(markdown)
      document.title = getPageTitle(this.type, this.langParam)
    }
  }
}
</script>

<style scoped lang="less">
.protocol-page {
  min-height: 100vh;
  background: #f7f8fa;
  text-align: left;
  box-sizing: border-box;
  padding: 24px 16px 40px;
}

.protocol-container {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.protocol-content {
  padding: 40px 48px;
  color: #333;
  font-size: 15px;
  line-height: 1.8;
  word-break: break-word;
}

@media screen and (max-width: 768px) {
  .protocol-page {
    padding: 12px 12px 24px;
  }

  .protocol-container {
    border-radius: 6px;
    box-shadow: none;
  }

  .protocol-content {
    padding: 20px 16px;
    font-size: 14px;
    line-height: 1.75;
  }
}
</style>

<style lang="less">
.protocol-content.markdown-body {
  h1 {
    margin: 0 0 24px;
    font-size: 28px;
    line-height: 1.4;
    font-weight: 600;
    color: #1a1a1a;
    text-align: center;
  }

  h2 {
    margin: 32px 0 16px;
    font-size: 20px;
    line-height: 1.5;
    font-weight: 600;
    color: #1a1a1a;
  }

  h3 {
    margin: 24px 0 12px;
    font-size: 17px;
    line-height: 1.5;
    font-weight: 600;
    color: #333;
  }

  p {
    margin: 0 0 12px;
  }

  strong {
    font-weight: 600;
    color: #1a1a1a;
  }

  hr {
    margin: 24px 0;
    border: none;
    border-top: 1px solid #e8e8e8;
  }

  ol,
  ul {
    margin: 0 0 12px;
    padding-left: 1.6em;
  }

  li {
    margin-bottom: 8px;
  }

  li > p {
    margin-bottom: 4px;
  }

  em {
    font-style: italic;
  }

  a {
    color: #1890ff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media screen and (max-width: 768px) {
  .protocol-content.markdown-body {
    h1 {
      margin-bottom: 16px;
      font-size: 22px;
    }

    h2 {
      margin: 24px 0 12px;
      font-size: 17px;
    }

    h3 {
      margin: 20px 0 10px;
      font-size: 15px;
    }

    ol,
    ul {
      padding-left: 1.4em;
    }
  }
}
</style>
